import { render, staticRenderFns } from "./Consultant.vue?vue&type=template&id=957549f4&scoped=true&"
import script from "./Consultant.vue?vue&type=script&lang=js&"
export * from "./Consultant.vue?vue&type=script&lang=js&"
import style0 from "./Consultant.vue?vue&type=style&index=0&id=957549f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957549f4",
  null
  
)

export default component.exports